/**
 * Тур по странице Billing (Рахунки та платежі).
 * Знакомит пользователя с функциями просмотра и скачивания счетов.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'billing-page',
  name: 'help.tours.billing.name',
  description: 'help.tours.billing.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Приветствие
    {
      element: '.page-title',
      titleKey: 'help.tours.billing.welcome.title',
      descriptionKey: 'help.tours.billing.welcome.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 2: Фильтр по статусу
    {
      element: '.invoice-filter',
      titleKey: 'help.tours.billing.filter.title',
      descriptionKey: 'help.tours.billing.filter.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 3: Таблица счетов
    {
      element: '.data-table',
      titleKey: 'help.tours.billing.table.title',
      descriptionKey: 'help.tours.billing.table.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 4: Статус счета
    {
      element: '.status-badge',
      titleKey: 'help.tours.billing.statusBadge.title',
      descriptionKey: 'help.tours.billing.statusBadge.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 5: Скачивание счета
    {
      element: '.button--icon',
      titleKey: 'help.tours.billing.download.title',
      descriptionKey: 'help.tours.billing.download.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 6: Итоговая сумма
    {
      element: '.invoice-total-row',
      titleKey: 'help.tours.billing.totalRow.title',
      descriptionKey: 'help.tours.billing.totalRow.description',
      side: 'top',
      align: 'end',
    },
    // Шаг 7: Пагинация
    {
      element: '.invoice-pagination',
      titleKey: 'help.tours.billing.pagination.title',
      descriptionKey: 'help.tours.billing.pagination.description',
      side: 'top',
      align: 'center',
    },
  ],
}
